import { useSelector } from "react-redux";
import { selectCategoriesByChannel } from "#menu";

/**
 * Provides a list of categories for the current menu (i.e. catering or OO).
 */
export const useCategories = () => {
    return useSelector(selectCategoriesByChannel);
};
